import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Typography from '@mui/material/Typography';
import { Box, LinearProgress } from '@mui/material';
import ImageSlider from './CarouselSlider';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const ACCENT_BLUE = '#22638f';
const ACCENT_ORANGE = '#d96c3c';
const TEXT_BODY = '#3b4a63';
const BORDER = '#eef2f8';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        width: '600px'
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function MessageModel({ open, onClose, type, pdfLink, setPdfLink }) {

    const navigate = useNavigate()
    const onHandleClose = () => {
        onClose(!open)
        setPdfLink([])
    }

    useEffect(() => {
        const handleBrowserBackButton = () => {
            if (open) {
                navigate(`/users/${localStorage.getItem('user_id')}`)
            }
        };

        window.addEventListener('popstate', handleBrowserBackButton);

        return () => {
            window.removeEventListener('popstate', handleBrowserBackButton);
        };
    }, [open]);

    return (
        <div>
            <BootstrapDialog
                fullScreen
                onClose={() => onClose(!open)}
                open={open}
            >
                <Box
                    sx={{
                        p: '14px 20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '14px',
                        borderBottom: `1px solid ${BORDER}`,
                    }}
                >
                    <IconButton
                        aria-label="go-back"
                        onClick={onHandleClose}
                        sx={{
                            color: '#fff',
                            backgroundColor: ACCENT_BLUE,
                            width: '34px',
                            height: '34px',
                            '&:hover': { backgroundColor: '#1a4d70' },
                        }}
                    >
                        <ArrowBackIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                    <Typography sx={{ fontSize: 15, fontWeight: 700, color: TEXT_BODY }}>
                        {type === 'pdf' ? 'Scan PDF' : 'Scan images'}
                    </Typography>
                </Box>
                <DialogContent dividers style={{ width: '100%', height: '100%', padding: '0px', borderColor: BORDER }}>
                    {pdfLink ? <div style={{ width: 'inherit', height: 'inherit' }}>
                        {(pdfLink && type === 'pdf') && <embed
                            title='pdf'
                            src={pdfLink}
                            style={{ width: '100%', height: '100%', }}
                        ></embed>}
                        {type === 'image' && <ImageSlider imageList={pdfLink} />}
                    </div> : (
                        <Box sx={{ p: 3 }}>
                            <LinearProgress sx={{ '& .MuiLinearProgress-bar': { backgroundColor: ACCENT_ORANGE }, backgroundColor: BORDER }} />
                        </Box>
                    )}
                </DialogContent>
            </BootstrapDialog>
        </div>
    );
}